import React, { forwardRef } from 'react';

import type { LowerGarmentColorsNullableParameter, LowerGarmentTypesNullableParameter } from '@vlabs/api/luna-api/model';
import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';

import { ColorGridFilter } from '@vlabs/monokit/shared/ui/color-grid-filter';
import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function LowerAttributesFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFilters } = useEventListFilters();

  const selectedColors = filters.lower_garment_colors ?? [];
  const selectedTypes = filters.lower_garment_types ?? [];

  const reset = () => updateFilters({
    lower_garment_colors: undefined,
    lower_garment_types: undefined,
  });

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={
        filters.lower_garment_colors === undefined
        && filters.lower_garment_types === undefined
      }
      onClickReset={reset}
      ref={ref}
    >
      <ColorGridFilter
        label={t('upper_clothing_colors')}
        onChange={(value) => updateFilters({
          lower_garment_colors: value.length > 0
            ? (value as unknown as LowerGarmentColorsNullableParameter)
            : undefined,
        })}
        options={EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.COLORS.raw}
        value={selectedColors as unknown as string[]}
      />

      <div className={st.Divider} />
      <div className={st.Subtitle}>{t('lower_garment_types')}</div>
      <div className={st.CheckboxContainer}>
        <OptionsFilter
          isSearchable={false}
          onChange={(value) => updateFilters({
            lower_garment_types: value.length > 0
              ? (value as unknown as LowerGarmentTypesNullableParameter)
              : undefined,
          })}
          options={EVENT_ENUMS.LOWER_BODY.LOWER_GARMENT.TYPE.raw}
          value={selectedTypes}
        />
      </div>
    </PopoverWithButton>
  );
}

const LowerAttributesFilterPopoverWithRef = forwardRef(LowerAttributesFilterPopover);
export { LowerAttributesFilterPopoverWithRef as LowerAttributesFilterPopover };
